'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isRadio = function isRadio(node) {
  return node.tagName === 'INPUT' && node.type === 'radio';
};

var findSelectedRadio = function findSelectedRadio(node, nodes) {
  return nodes.filter(isRadio).filter(function (el) {
    return el.name === node.name;
  }).filter(function (el) {
    return el.checked;
  })[0] || node;
};

var pickFirstFocus = function pickFirstFocus(nodes) {
  if (nodes[0] && nodes.length > 1) {
    if (isRadio(nodes[0]) && nodes[0].name) {
      return findSelectedRadio(nodes[0], nodes);
    }
  }
  return nodes[0];
};

exports.default = pickFirstFocus;


//////////////////
// WEBPACK FOOTER
// ./~/focus-lock/dist/cjs/utils/firstFocus.js
// module id = 1768
// module chunks = 0